import * as React from "react";
const SvgBird = props => <svg id="svg225" xmlSpace="preserve" viewBox="0 0 682.66669 682.66669" xmlns="http://www.w3.org/2000/svg" xmlnsSvg="http://www.w3.org/2000/svg" {...props}><defs id="defs229"><clipPath clipPathUnits="userSpaceOnUse" id="clipPath239"><path d="M 0,512 H 512 V 0 H 0 Z" id="path237" /></clipPath></defs><g id="g231" transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g id="g233"><g id="g235" clipPath="url(#clipPath239)"><g id="g241" transform="translate(384.501,464.8667)"><path d="m 0,0 c 44.385,0 80.365,-35.981 80.365,-80.366 v -96.367 C 80.365,-265.467 8.431,-337.4 -80.301,-337.4 h -192.8 c 106.48,0 192.8,86.32 192.8,192.8 v 60.334 c 0,23.092 9.172,45.24 25.502,61.568 C -40.267,-8.164 -20.555,0 -0.002,0 Z" style={{
            fill: "none",
            stroke: "currentColor",
            strokeWidth: 20,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            strokeDasharray: "none",
            strokeOpacity: 1
          }} id="path243" /></g><g id="g245" transform="translate(497,464.8667)"><path d="M 0,0 -41.914,-41.914" style={{
            fill: "none",
            stroke: "currentColor",
            strokeWidth: 20,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            strokeDasharray: "none",
            strokeOpacity: 1
          }} id="path247" /></g><g id="g249" transform="translate(400.5996,414.5332)"><path d="m 0,0 c -8.279,0 -15,-6.722 -15,-15 0,-8.278 6.721,-15 15,-15 8.278,0 15,6.722 15,15 C 15,-6.722 8.278,0 0,0" style={{
            fill: "currentColor",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none"
          }} id="path251" /></g><g id="g253" transform="translate(15,127.4668)"><path d="m 0,0 h 96.4 c 106.48,0 192.8,86.32 192.8,192.8 v 60.334 c 0,23.092 9.172,45.24 25.502,61.568 z" style={{
            fill: "none",
            stroke: "currentColor",
            strokeWidth: 20,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            strokeDasharray: "none",
            strokeOpacity: 1
          }} id="path255" /></g><g id="g257" transform="translate(288.1338,47.1333)"><path d="M 0,0 -80.334,80.333" style={{
            fill: "none",
            stroke: "currentColor",
            strokeWidth: 20,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            strokeDasharray: "none",
            strokeOpacity: 1
          }} id="path259" /></g><g id="g261" transform="translate(239.9336,47.1333)"><path d="M 0,0 H 96.399" style={{
            fill: "none",
            stroke: "currentColor",
            strokeWidth: 20,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            strokeDasharray: "none",
            strokeOpacity: 1
          }} id="path263" /></g></g></g></g></svg>;
export default SvgBird;